import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const styles = {
  page: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f5f5f5',
  },
  card: {
    background: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: '8px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  logo: {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '4px',
  },
  sub: {
    color: '#666',
    fontSize: '13px',
    marginBottom: '32px',
  },
  loginBtn: {
    width: '100%',
    padding: '12px',
    background: '#fd5f0d',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  note: {
    marginTop: '16px',
    fontSize: '12px',
    color: '#999',
  },
};

function LoginPage() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>RAAH</div>
        <div style={styles.sub}>Partner Portal</div>
        <button style={styles.loginBtn} onClick={() => loginWithRedirect()}>
          Log in with Auth0
        </button>
        <div style={styles.note}>
          Access is restricted to authorized partners.
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
